import { useContext } from "react";
import { DictionaryContext } from "../../contexts/dictionary/dictionary-provider";

export const useDictionary = () => useContext(DictionaryContext);
